import React from 'react';
import { useLocale } from '@gov-nx/core/service';
import { useZdravDokumentaceContext } from '@gov-nx/module/page';
import {
	Button,
	ButtonGroupLayout,
	ContentLayout,
	ErrorStatusBanner,
	InfoBanner,
	LayoutGap,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { HealthDocumentationSkeleton } from './HealthDocumentationSkeleton';

export const HealthDocumentationView = () => {
	const { code, controls, documents, handleDownload, handleSaveToFiles } =
		useZdravDokumentaceContext();
	const { t } = useLocale(code);
	const isProcessing = controls.processLoading || controls.downloadLoading;

	if (controls.initialLoading) {
		return <HealthDocumentationSkeleton />;
	}

	if (controls.initialError) {
		return <ErrorStatusBanner code={code} />;
	}

	if (Array.isArray(documents) && documents.length === 0) {
		return (
			<ContentLayout>
				<InfoBanner
					headline={t('stav.chyba.zadna-dokumentace')}
					text={t('stav.chyba.zadne-zaznamy')}
				/>
			</ContentLayout>
		);
	}

	return (
		<ContentLayout>
			<LayoutGap gap="m">
				<Tiles>
					{documents?.map((document) => (
						<Tile
							key={document.ehealthDocumentId}
							name={document.sourceName}>
							<p className="mb-(--spacing-m-nudge)!">
								{t('pole.udaje.identifikacni-cislo')}{' '}
								<strong>{document.sourceIco}</strong>,{' '}
								{t('pole.udaje.platnost-od')}{' '}
								<strong>{document.effectiveTime}</strong>
							</p>
							<ButtonGroupLayout customClasses="justify-start flex-col! [ md:flex-row! ]">
								<Button
									onClick={() => handleDownload(document)}
									isDisabled={isProcessing}
									isLoading={
										document.sourceIdentifier === controls.downloadDocumentId
									}
									nativeType="button"
									color="primary"
									size="m"
									type="solid"
									isExpandedMobile
									aria-label={t('akce.wcag.stahnout-dokumentaci')}>
									{t('akce.stahnout-dokumentaci')}
								</Button>
								<Button
									onClick={() => handleSaveToFiles(document)}
									isDisabled={isProcessing}
									isLoading={
										document.sourceIdentifier === controls.submitDocumentId
									}
									nativeType="button"
									color="primary"
									size="m"
									type="outlined"
									isExpandedMobile
									aria-label={t('akce.wcag.ulozit-do-souboru')}>
									{t('akce.ulozit-do-souboru')}
								</Button>
							</ButtonGroupLayout>
						</Tile>
					))}
				</Tiles>
			</LayoutGap>
		</ContentLayout>
	);
};
